import React from "react";

export default function Alert() {
  return (
    <div className="alert alert-success mt-2" role="alert">
      Tarea Agregada
    </div>
  );
}
